import * as React from "react"

const GridSvg = (props: any) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        fill="#E9ECEF"
        {...props}
        viewBox={'0 0 32 32'}
    >
        <rect width={32} height={32} fill="inherit" stroke={'none'} rx={2}/>
        <path
            fill="#333"
            stroke={'none'}
            d="M8 8h7v7H8V8ZM8 17h7v7H8v-7ZM16 8h8v3h-8V8ZM16 17h8v3h-8v-3ZM16 12h8v3h-8v-3ZM16 21h8v3h-8v-3Z"
        />
    </svg>
)

export default GridSvg